import React from "react";
import { useAccessControl } from "../../Hooks/useAccessControl";

const Can = ({ action, children, fallback = null }) => {
  const { hasPermission } = useAccessControl();

  return hasPermission(action) ? children : fallback;
};

export default Can;
